// client/src/routes/app/contracts/$contractId/documents.tsx — SCR-CON-003 tab „Documente" ·
// CON-005 phase 1 (the seam), phase 2 (CON-004's downloads).
//
// CON-004 generates the four `ContractDocumentKind` PDFs — contract, proces verbal, inventar,
// fișă index — and serves them from `GET /contracts/{id}/documents/{kind}`. That item is not on
// develop as phase 1 is written, so the panel names what it is waiting for rather than this
// route guessing at a download shape it cannot compile against.
//
// TWO PANELS, IN THIS ORDER (D-2020). The papers the landlord filed come first and the four the
// server prints come second: a tab titled „Documente" that opened on generated drafts, with the
// signed original nowhere on it, is the gap this item closes, and ordering is how a screen says
// which of two sections answers the question that brought the user here. They are separate
// sections rather than one list because they are separate things — one is a stored file with a
// version history and a hash, the other is a rendering of the contract's own data that exists
// only for the length of the download.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { AttachedDocumentsPanel, DocumentsPanel } from '@/features/contracts/panels';
import { useContract } from '@/features/contracts/queries';

export const Route = createFileRoute('/app/contracts/$contractId/documents')({
  component: DocumentsTabScreen,
});

function DocumentsTabScreen() {
  const { contractId } = Route.useParams();
  const contract = useContract(contractId);

  if (contract.isPending) return <LoadingState rows={2} />;
  if (contract.isError) return <ErrorState error={contract.error} onRetry={() => void contract.refetch()} />;

  return (
    <>
      <AttachedDocumentsPanel
        contractId={contractId}
        contractNumber={contract.data.contractNumber}
        propertyId={contract.data.propertyId}
      />
      <DocumentsPanel
        contractId={contractId}
        contractNumber={contract.data.contractNumber}
        propertyId={contract.data.propertyId}
      />
    </>
  );
}
